import React, { useEffect, useState } from 'react';
import { Col, Form, FormInstance, Grid, Message, Row, Schema } from "rsuite";
import { RunClubTypeStoryChapterTask, UpsertRunClubTypeStoryChapterTask } from '@/models/story-chapter-task.model';
import FetchingTagPicker from '@/components/FetchingTagPicker';
import { getRunningClubsLookup } from '@/services/running-club.service';

const modelSchema = Schema.Model<UpsertRunClubTypeStoryChapterTask>({
  runClubIds: Schema.Types.ArrayType(),
});
const emptyModel: UpsertRunClubTypeStoryChapterTask = {
  runClubIds: undefined,
};

interface RunClubTypeTaskFormFormProps{
  formObject?: RunClubTypeStoryChapterTask;
  onFormChange: (formValue: any) => void;
  formRef: React.Ref<FormInstance<Record<string, any>>>;
  loading: number;
}

const RunClubTypeTaskForm: React.FC<RunClubTypeTaskFormFormProps> = ({ formObject, onFormChange, formRef, loading }) => {
  const [formValue, setFormValue] = useState<UpsertRunClubTypeStoryChapterTask>(emptyModel);
  
  useEffect(() => {
    if (formObject) {
      setFormValue(formObject);
    } else {
      setFormValue(emptyModel);
    }
  }, [formObject]);

  useEffect(() => {
    onFormChange(formValue);
  }, [formValue]);
  
  return (
    <Form name='upsert-run-club-task-type' fluid
        ref={formRef}
        formValue={formValue}
        model={modelSchema}
        disabled={!!loading}
    >    
      <Grid w='100%' fluid>
        <Row>
          <Col span={{xs:24}}>
            <Form.Group controlId="runClubIds">
              <Form.Label>Run Clubs</Form.Label>
              <Form.Control name="runClubIds" accepter={FetchingTagPicker} block
                fetchData={(text, page) => getRunningClubsLookup(text, page)} 
                placeholder="Select a Run Club"
                value={formValue.runClubIds}
                onChange={val=> setFormValue(pre => ({...pre, runClubIds: val}))}
              />   
            </Form.Group>
          </Col>
        </Row>
        <Row>
          <Message showIcon type="info">
            User should run base on run club event routes. Amount: count of run clubs.
          </Message>
        </Row>         
      </Grid>
    </Form>
  );
};

export default RunClubTypeTaskForm;